import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AggridObjecttypeTooltipComponent } from './aggrid-objecttype-tooltip.component';

@NgModule({
  declarations: [AggridObjecttypeTooltipComponent],
  exports: [AggridObjecttypeTooltipComponent],
  imports: [CommonModule],
})
export class AggridObjecttypeTooltipComponentModule {}
